import type { ITextBlockDescriptionType1 } from 'blocks/TextBlock/Templates'
import type { IMultiColumnsItemProps } from '../../MultiColumnsItem'

import { TextBlockDirection } from 'blocks/TextBlock'
import { TextBlockDescriptionType1 } from 'blocks/TextBlock/Templates'
import {
  MultiColumnsAlignItems,
  MultiColumnsDirection,
  MultiColumnsJustifyContent,
  MultiColumnsRowGap,
} from '../../MultiColumns.h'
import { MCItemDirectorsStarsSC } from './MCItemDirectorsStars.styled'

export interface IMCItemDirectorsStars extends Omit<
  IMultiColumnsItemProps & ITextBlockDescriptionType1,
  | 'children'
  | 'rowGap'
  | 'title'
  | 'description'
  | 'direction'
  | 'alignItems'
  | 'justifyContent'
> {
  directors?: string
  stars?: string
  rowGap?: MultiColumnsRowGap
  directionText?: TextBlockDirection
  directorsTitle?: string
  starsTitle?: string
  direction?: MultiColumnsDirection
  alignItems?: MultiColumnsAlignItems
  justifyContent?: MultiColumnsJustifyContent
}

export const MCItemDirectorsStars = ({
  directors,
  stars,
  rowGap = MultiColumnsRowGap.INDENT_10,
  flexBasisAuto = true,
  directionText = TextBlockDirection.ROW,
  width,
  directorsTitle = 'Directors',
  starsTitle = 'Stars',
  direction = MultiColumnsDirection.Column,
  alignItems = MultiColumnsAlignItems.FlexStart,
  justifyContent = MultiColumnsJustifyContent.FlexStart,
  columnGap,
  ...rest
}: IMCItemDirectorsStars) => (
  <MCItemDirectorsStarsSC
    rowGap={rowGap}
    width={width}
    direction={direction}
    alignItems={alignItems}
    justifyContent={justifyContent}
    columnGap={columnGap}
    {...rest}
  >
    {directors && (
      <TextBlockDescriptionType1
        direction={directionText}
        flexBasisAuto={flexBasisAuto}
        title={directorsTitle}
        description={directors || ''}
        width={width || 100}
      />
    )}
    {stars && (
      <TextBlockDescriptionType1
        direction={directionText}
        flexBasisAuto={flexBasisAuto}
        title={starsTitle}
        description={stars || ''}
        width={width || 100}
      />
    )}
  </MCItemDirectorsStarsSC>
)
